import { render, staticRenderFns } from "./UserAdministration.vue?vue&type=template&id=809d2e36&scoped=true&"
import script from "./UserAdministration.vue?vue&type=script&lang=js&"
export * from "./UserAdministration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "809d2e36",
  null
  
)

export default component.exports